/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import {
  NavLink,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import EditIcon from "@mui/icons-material/Edit";

import {
  Alert,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  ButtonGroup,
  CircularProgress,
  ClickAwayListener,
  Grid,
  Grow,
  IconButton,
  Link,
  MenuItem,
  MenuList,
  Paper as MuiPaper,
  Popper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { Add as AddIcon, ArrowDropDown } from "@mui/icons-material";
import { spacing } from "@mui/system";
import { withStyles } from "@mui/styles";
import axios from "../../CustomAxios";
import { connect } from "react-redux";
import Loading from "../components/Loading";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const StyledTableContainer = withStyles((theme) => ({
  root: {
    // width: "max-content",
  },
}))(TableContainer);

const Spacer = styled.div`
  flex: 1 1 100%;
`;

const ToolbarTitle = styled.div`
  min-width: 150px;
`;

function createData(id, name, permissions, user_type) {
  return {
    id,
    name,
    permissions,
    user_type,
  };
}

const headCells = [
  { id: "id", alignment: "left", label: "Sr No." },
  { id: "name", alignment: "left", label: "RoleName" },
];

const EnhancedTableHead = (props) => {
  const { editPermission } = props;
  const [head, setHeads] = useState(headCells);

  useEffect(() => {
    if (editPermission) {
      setHeads((prev) => [
        ...prev,
        { id: "edit", alignment: "center", label: "Edit" },
      ]);
    }
  }, [editPermission]);

  return (
    <TableHead>
      <TableRow>
        {head.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.alignment}
            padding={headCell.disablePadding ? "none" : "normal"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const EnhancedTableToolbar = (props) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  // Here was 'let'
  const {
    setRows,
    setLoader,
    setTotal,
    page,
    setPage,
    rowsPerPage,
    searchParams,
    setSelectedIndex,
    selectedIndex,
  } = props;
  const navigate = useNavigate();
  const authData = JSON.parse(localStorage.getItem("AuthData"));

  const options = ["Alpha Plus User Roles", "Customer Company User Roles"];
  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
    setPage(0)
  };
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const buttonGroup = () => {
    return (
      <Paper style={{ textAlign: "right" }}>
        <ButtonGroup
          variant="contained"
          ref={anchorRef}
          aria-label="split button"
        >
          <Button style={{ width: "max-content", cursor: "default" }}>
            {options[selectedIndex]}
          </Button>
          <Button
            size="small"
            aria-controls={open ? "split-button-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            aria-label="select merge strategy"
            aria-haspopup="menu"
            onClick={handleToggle}
          >
            <ArrowDropDown />
          </Button>
        </ButtonGroup>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id="split-button-menu" autoFocusItem>
                    {options.map((option, index) => (
                      <MenuItem
                        key={option}
                        selected={index === selectedIndex}
                        onClick={(event) => handleMenuItemClick(event, index)}
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Paper>
    );
  };

  return (
    <Toolbar>
      <ToolbarTitle>
        <Typography color={"primary"} variant="h6" id="tableTitle">
          All Roles
        </Typography>
      </ToolbarTitle>
      <Spacer />
      {authData?.type !== "customer_user" ? buttonGroup() : null}
      <Tooltip title="Create Role">
        <IconButton size="large">
          <AddIcon onClick={() => navigate("/dashboard/roles/create-role")} />
        </IconButton>
      </Tooltip>
    </Toolbar>
  );
};

const getRoles = async (
  setRows,
  setLoader,
  type,
  setTotal,
  searchParams,
  page,
  rowsPerPage
) => {
  let queryPage = searchParams.get("page");
  let queryLimit = searchParams.get("limit");
  setLoader(true);

  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));

    let url = `/api/v1/${userData.type}/role?`;

    queryPage ? (queryPage = Number(queryPage) + 1) : (queryPage = page + 1);
    // eslint-disable-next-line no-self-assign
    queryLimit ? (queryLimit = queryLimit) : (queryLimit = rowsPerPage);

    url += `page=${queryPage}&limit=${queryLimit}`;

    url += `&user_type=${type}`;

    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };
    let allRoles = [];
    const { data } = await axios.get(url, config);
    if (data.success) {
      data.data.data.map((role) => {
        allRoles.push(
          createData(role._id, role.role_name, role.permissions, role.user_type)
        );
      });

      setTotal(data.data.metadata.total_results);
    }
    setRows(allRoles);
    setLoader(false);
  } catch (e) {
    console.log(e, "error");
  }
  setLoader(false);
};

function EnhancedTable({
  editPermission,
  rows,
  setSelectedIndex,
  selectedIndex,
  setRows,
  page,
  setPage,
  loader,
  setTotal,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  searchParams,
  total,
}) {
  const anchorRef = React.useRef(null);
  const navigate = useNavigate();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("customer");
  const [selected, setSelected] = React.useState([]);
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const [message, setMessage] = useState(location?.state?.message);
  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  useEffect(() => {
    if (location?.state?.success) {
      snackRef.current.click();
      navigate(location.pathname, { replace: true });
    }
  }, [location?.state]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  if (!loader) {
    return (
      <div>
        <Button
          ref={snackRef}
          style={{ display: "none" }}
          onClick={handleClick({ vertical: "top", horizontal: "center" })}
        >
          Click
        </Button>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          onClose={handleClose}
          key={vertical + horizontal}
        >
          <Alert mt={2} mb={4} severity="success">
            {message}
          </Alert>
        </Snackbar>
        <Paper>
          <EnhancedTableToolbar
            setRows={setRows}
            setTotal={setTotal}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setLoader={setLoading}
            searchParams={searchParams}
            anchorRef={anchorRef}
            numSelected={selected.length}
            setSelectedIndex={setSelectedIndex}
            selectedIndex={selectedIndex}
          />
          <StyledTableContainer>
            <Table size={"small"}>
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
                editPermission={editPermission}
              />
              {!loading ? (
                <TableBody>
                  {rows.map((row, index) => {
                    const isItemSelected = isSelected(row.id);
                    return (
                      <TableRow
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={`${row.id}-${index}`}
                        selected={isItemSelected}
                      >
                        <TableCell align="left">
                          {" "}
                          {Number(page) * Number(rowsPerPage) + index + 1}
                        </TableCell>
                        <TableCell align="left">{row.name}</TableCell>
                        {editPermission ? (
                          <TableCell align="center">
                            <EditIcon
                              style={{ cursor: "pointer", color: "red" }}
                              onClick={() =>
                                navigate("/dashboard/roles/edit-role", {
                                  state: {
                                    role: row,
                                  },
                                })
                              }
                            />
                          </TableCell>
                        ) : null}
                      </TableRow>
                    );
                  })}
                </TableBody>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell />
                    <TableCell align="center" sx={{ padding: "40px 0" }}>
                      <CircularProgress />
                    </TableCell>
                    <TableCell />
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </StyledTableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    );
  } else {
    return <Loading />;
  }
}

function ViewRole({ auths }) {
  const [loader, setLoader] = useState(true);
  const [rows, setRows] = useState([]);
  const [editPermission, setEditPermission] = useState(false);
  const authData = JSON.parse(localStorage.getItem("AuthData"));
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const [searchParams] = useSearchParams();

  const [page, setPage] = React.useState(
    searchParams.get("page") ? Number(searchParams.get("page")) : 0
  );
  const [rowsPerPage, setRowsPerPage] = React.useState(
    searchParams.get("limit") ? Number(searchParams.get("limit")) : 10
  );
  const [total, setTotal] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(async () => {
    if (authData?.type === "customer_user" || selectedIndex === 1) {
      getRoles(
        setRows,
        setLoader,
        "customer_company_user",
        setTotal,
        searchParams,
        page,
        rowsPerPage
      );
    } else {
      getRoles(
        setRows,
        setLoader,
        "ap_company_user",
        setTotal,
        searchParams,
        page,
        rowsPerPage
      );
    }
    if (
      auths?.user?.role?.permissions.includes("edit_role") ||
      authData?.type === "super_admin"
    ) {
      setEditPermission(true);
    }
  }, [auths?.user, page, rowsPerPage, selectedIndex]);

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              ROLES
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Typography>Roles</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <EnhancedTable
              editPermission={editPermission}
              rows={rows}
              setSelectedIndex={setSelectedIndex}
              selectedIndex={selectedIndex}
              setTotal={setTotal}
              searchParams={searchParams}
              rowsPerPage={rowsPerPage}
              loader={loader}
              setRows={setRows}
              total={total}
              page={page}
              setPage={setPage}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              setLoader={setLoader}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});
export default connect(mapStateToProps, null)(ViewRole);
